import { TrackRoute } from '@portals/shared-frontend/components';

import HeroPage from '@/components/HeroPage';

import DeveloperPortalGuideContent from '../../../components/Guide/DeveloperPortalGuideContent';

export default function GettingStartedAPIConsumers() {
  return (
    <HeroPage
      banner="common"
      noTopMargin
      subtitle="Follow these steps to start consuming APIs"
      tabTitle="Getting started - Consumers"
      title="Getting started for DNB internal API consumers"
    >
      <TrackRoute name="Internal Consumers" path="/getting-started/dnb-internal-consumers" type="generic" />
      <DeveloperPortalGuideContent contentSlug="consuming-apis" />
    </HeroPage>
  );
}
